import React, { createContext, useContext } from 'react';

const OrderReturnContext = createContext();

export const OrderReturnContextProvider = ({ values, children }) => {
  return <OrderReturnContext.Provider value={values}>{children}</OrderReturnContext.Provider>;
};

export const useOrderReturnContext = () => useContext(OrderReturnContext);
